"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hideVisually = _interopRequireDefault(require("../../../theming/styles/hideVisually"));

var _Digit = _interopRequireDefault(require("./Digit"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Odometer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Odometer, _React$PureComponent);

  function Odometer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Odometer);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Odometer)).call.apply(_getPrototypeOf2, [this].concat(props)));
    _this.state = {
      isAnimating: false
    };
    _this.timeout = null;
    _this.animate = _this.animate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Odometer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.animate();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.number !== nextProps.number) {
        this.animate();
      }
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this2 = this;

      this.setState({
        isAnimating: true
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.setState({
          isAnimating: false
        });
      }, this.props.speed + 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          number = _this$props.number,
          speed = _this$props.speed,
          size = _this$props.size,
          separatorSteps = _this$props.separatorSteps,
          variant = _this$props.variant,
          restProps = _objectWithoutProperties(_this$props, ["number", "speed", "size", "separatorSteps", "variant"]);

      var isAnimating = this.state.isAnimating;
      var chars = parseInt(number, 10).toString().replace("-", "").split("");
      var digitLength = chars.length;
      var numSeparators = digitLength / separatorSteps;

      for (var i = 0; i < numSeparators; i++) {
        // TODO: There HAS to be a smarter way of doing this. Brain is not working atm
        chars.splice(digitLength - separatorSteps * i, 0, "");
      }

      var renderDigits = function renderDigits(digit, single, speed) {
        return chars.map(function (digit, i) {
          return _react["default"].createElement(OdometerContainer, {
            key: "digit-".concat(i),
            variant: variant
          }, _react["default"].createElement(_Digit["default"], {
            size: size,
            digit: digit,
            single: single,
            speed: speed,
            variant: variant
          }));
        });
      };

      return _react["default"].createElement(OdometerWrapper, _extends({
        size: size,
        variant: variant
      }, restProps), _react["default"].createElement(OdometerStatic, {
        isAnimating: isAnimating,
        variant: variant
      }, renderDigits(number, true, speed)), _react["default"].createElement(OdometerAnimating, {
        isAnimating: isAnimating,
        variant: variant
      }, renderDigits(number, false, speed)));
    }
  }]);

  return Odometer;
}(_react["default"].PureComponent);

Odometer.themeProps = {
  animating: {
    name: "odometer_animating",
    description: "Style for the animating odometer",
    type: _themeContants.themePropTypes.style
  },
  "static": {
    name: "odometer_static",
    description: "Style for the static odometer",
    type: _themeContants.themePropTypes.style
  },
  container: {
    name: "odometer_container",
    description: "Style for the container",
    type: _themeContants.themePropTypes.style
  },
  wrapper: {
    name: "odometer_wrapper",
    description: "Style for the wrapper",
    type: _themeContants.themePropTypes.style
  }
};

var OdometerAnimating = _styledComponents["default"].div.withConfig({
  displayName: "Odometer__OdometerAnimating",
  componentId: "sc-19ifzsj-0"
})(["", ";", ";"], function (p) {
  return !p.isAnimating ? _hideVisually["default"] : "display: flex;";
}, (0, _theming.applyVariants)(Odometer.themeProps.animating));

var OdometerStatic = _styledComponents["default"].div.withConfig({
  displayName: "Odometer__OdometerStatic",
  componentId: "sc-19ifzsj-1"
})(["", ";", ";"], function (p) {
  return p.isAnimating ? _hideVisually["default"] : "display: flex;";
}, (0, _theming.applyVariants)(Odometer.themeProps["static"]));

var OdometerContainer = _styledComponents["default"].div.withConfig({
  displayName: "Odometer__OdometerContainer",
  componentId: "sc-19ifzsj-2"
})(["position:relative;", ";"], (0, _theming.applyVariants)(Odometer.themeProps.container));

var OdometerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Odometer__OdometerWrapper",
  componentId: "sc-19ifzsj-3"
})(["font-size:", "px;line-height:1;display:inline-block;", ";"], function (p) {
  return p.size;
}, (0, _theming.applyVariants)(Odometer.themeProps.wrapper)); // TODO: Add support for strings?


Odometer.propTypes = {
  /**
   * Value to tween to
   */
  number: _propTypes["default"].number.isRequired,
  separatorSteps: _propTypes["default"].number,
  speed: _propTypes["default"].number,
  size: _propTypes["default"].number.isRequired
};
Odometer.defaultProps = {
  number: 0,
  separatorSteps: 3,
  size: 32,
  speed: 500
};
var _default = Odometer;
exports["default"] = _default;